const VOICES_BY_GENDER = {
  feminine: ['coral', 'nova', 'shimmer'],
  masculine: ['onyx', 'echo', 'ash'],
};

const ALL_VOICES = [
  'alloy',
  'ash',
  'coral',
  'echo',
  'fable',
  'nova',
  'onyx',
  'sage',
  'shimmer',
];

const DEFAULT_VOICE_BY_GENDER = {
  feminine: 'nova',
  masculine: 'onyx',
  neutral: 'alloy',
  custom: 'alloy',
};

export const openAiTtsVoicesForGender = gender =>
  VOICES_BY_GENDER[gender] || ALL_VOICES;

export const defaultOpenAiTtsVoice = gender =>
  DEFAULT_VOICE_BY_GENDER[gender] || DEFAULT_VOICE_BY_GENDER.neutral;

export const resolveOpenAiTtsVoice = (voice, gender) => {
  const available = openAiTtsVoicesForGender(gender);
  return available.includes(voice) ? voice : defaultOpenAiTtsVoice(gender);
};
